import { render } from "./BarcodePrinter.vue?vue&type=template&id=21528784&scoped=true&ts=true"
import script from "./BarcodePrinter.vue?vue&type=script&lang=ts"
export * from "./BarcodePrinter.vue?vue&type=script&lang=ts"

import "./BarcodePrinter.vue?vue&type=style&index=0&id=21528784&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21528784"]])

export default __exports__